import { useQueryClient, useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import uuid from "react-native-uuid"
import { removeValue, storeValue } from "../../utils"
import { DEMO_PHONE_NUMBER } from "../../constants"
import { getDeviceId } from "../../utils/deviceId"

type PhoneNumberResponse = {
  verificationId: string
  phoneNumberExists: boolean
  errors?: string[] | null
  redirectUrl?: string | null
  linkToken?: {
    tokenId: string
    linkToken: string
    expiration: string
  }
}
type MutationFnParams = {
  phoneNumber: string
  registrationToken?: string
  /** Phone auth owns the error screen so the API message can be shown once. */
  disableErrorScreen?: boolean
}

export function useVerifyPhoneNumber() {
  const queryClient = useQueryClient()

  return useMutation<PhoneNumberResponse, unknown, MutationFnParams>({
    mutationFn: async ({ phoneNumber, registrationToken, disableErrorScreen }) => {
      if (phoneNumber?.replaceAll("-", "") === DEMO_PHONE_NUMBER) {
        await storeValue("mode", "demo")
      } else {
        await removeValue("mode")
      }

      const response = await fetcher(
        "/Verification/VerifyPhoneNumber",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phoneNumber,
            registrationToken: registrationToken || uuid.v4(),
            deviceId: getDeviceId(),
          }),
        },
        { disableErrorScreen }
      )

      const responseJson = await response.json()

      return responseJson
    },
    onSuccess: (response, variables) => {
      // Query cache only — these hooks mount above PlaidProvider, so context setters are no-ops.
      queryClient.setQueryData(["phoneNumberVerificationId"], response.verificationId)
      queryClient.setQueryData(["signUpPhoneNumber"], variables.phoneNumber)
      queryClient.setQueryData(["onboardingLinkToken"], response.linkToken)
    },
  })
}
